import React,{useState, useEffect} from 'react';
import { NavLink, Link } from 'react-router-dom';
import './Footer.css'
import ourmissionicon from '../Images/ourmissionicon.png';
import shopit from '../Images/shopit.png';
import shopitBlue from '../Images/shopitBlue.png';
import shopitBlack from '../Images/shopitBlack.png';
import contactusicon from '../Images/contactusicon.png';
import facebookicon from '../Images/facebookicon.png';
import instagramicon from '../Images/instagramicon.png';
import tiktokicon from '../Images/tiktokicon.png';
import coder from '../Images/coder.png';
import Logo from '../Images/logo.png';
import { motion } from "framer-motion";

const Footer = () => {
  return (
    <>
    <motion.footer
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
    >
        <motion.div className='footer-container'
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}>
          <motion.div className='ourmission-container'
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          >
            <h3>
              <img src={ourmissionicon} alt="OurMissionIconError" />
              Our Mission
            </h3>
            <p>DayRine aims to bring you stylish and reliable products that enhance your everyday life. From watches, earbuds, wallets, and cosmetics, we focus on quality, affordability, and customer satisfaction.</p>
          </motion.div>

          <motion.div className='footer-logo-container'
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          >
            <Link to="/" className='logo-link'><img src={Logo} alt='error' /></Link>
          </motion.div>

          <motion.div className='contact-us-container'
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          >
            <h3>
              <img src={contactusicon} alt="ContactUsIconError" />
              Contact Us
            </h3>
            <p>
              Email Address:<br/>
              <a href="https://mail.google.com/mail/u/0/?tab=rm&ogbl#inbox?compose=new" target="_blank" rel="noopener noreferrer" style={{textDecoration:'none', color:'white'}}>
                support.dayrine@gmail.com
              </a>
            </p>
            <p>
              WhatApp No:<br/>
              +92326-5292748
            </p>
          </motion.div>
        </motion.div>

          <motion.div className='social-media-link-container'
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          >
            <a href="https://wa.me/923265292748" target="_blank" rel="noopener noreferrer" >
              <i class="ri-whatsapp-fill"></i>
            </a>
            <a href="https://www.facebook.com/61576407604023/" target="_blank" rel="noopener noreferrer" > 
              {/* <img src={facebookicon} alt="Facebook" /> */}
              <i class="ri-facebook-circle-fill"></i>
            </a>
            <a href="https://m.youtube.com/@dayrinestore" target="_blank" rel="noopener noreferrer" >
              <i class="ri-youtube-fill"></i>
            </a>
            {/* <a href="https://www.instagram.com/inpkonlineshop.official/" target="_blank" rel="noopener noreferrer" >
              <img src={instagramicon} alt="Instagram" />
            </a>
            <a href="https://www.tiktok.com/@inpkonlineshop?_t=ZT-8v0ledlhzfH&_r=1" target="_blank" rel="noopener noreferrer" > 
              <img src={tiktokicon} alt="Tiktok" style={{marginLeft:'-5px'}}/>
            </a> */}
          </motion.div>

          <motion.p className='copyright'
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          >
            © 2023, Copyright DayRine®. All rights reserved.
          </motion.p>

          <motion.div className='terms-and-conditions-container' 
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          >
            <Link to="/refundpolicy" className='terms-and-condition-link' >
              Refund Policy
            </Link>
            <Link to="/privcypolicy" className='terms-and-condition-link'>
              Privacy Policy
            </Link>
            <Link to="/termsofservice" className='terms-and-condition-link'>
              Terms of Service
            </Link>
            <Link to="/shippingpolicy" className='terms-and-condition-link'>
              Shipping Policy
            </Link>
            <Link to="/contactinformation" className='terms-and-condition-link'>
              Contact Information
            </Link>
          </motion.div>

          <motion.label className='my-tag'
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          >
            {/* ❤️ */}
            {/* <img src={coder} alt="developer"/> */}
          </motion.label>
          
      </motion.footer>
    </>
  )
}

export default Footer